export default["__VITE_ASSET__CVM54b9L__","__VITE_ASSET__BuqItmUH__"];